import Vue from 'vue'
import App from './App.vue'
import ElementUi from 'element-ui'
import '@/styles/theme/element-#00A5B2/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
Vue.use(ElementUi, { locale })
import router from './router'
import store from './store'
import '@/styles/index.scss'
import '@/icons' // icon
import '@/permission'
import '@/utils/ws'
import { setRem, getFontSize } from './rem'
setRem()
import vueXlsxTable from 'vue-xlsx-table'
Vue.use(vueXlsxTable, {rABS: false})

/* Vue.prototype.$echarts = echarts;*/
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        setRem()
        that.$store.state.app.screenWidth = document.documentElement.clientWidth // 窗口宽度
        that.$store.state.app.screenHeight = document.documentElement.clientHeight // 窗口高度
        that.$store.state.app.fontSize = getFontSize()
      })()
    }
  }
}).$mount('#app')
